
export enum NodeType {
  ENTRANCE = 'ENTRANCE', 
  AMBULANCE_ENTRANCE = 'AMBULANCE_ENTRANCE',
  RECEPTION = 'RECEPTION',
  TRIAGE = 'TRIAGE',
  WAITING = 'WAITING',
  EXAM_ROOM = 'EXAM_ROOM',
  PROCEDURE_ROOM = 'PROCEDURE_ROOM',
  UTILITY_ROOM = 'UTILITY_ROOM',
  ISOLATION_ROOM = 'ISOLATION_ROOM',
  TRAUMA_BAY = 'TRAUMA_BAY',
  RADIOLOGY = 'RADIOLOGY', 
  LABORATORY = 'LABORATORY',
  PHARMACY = 'PHARMACY',
  WARD = 'WARD',
  HALLWAY = 'HALLWAY',
  STAFF_STATION = 'STAFF_STATION',
  STAFF_REST = 'STAFF_REST',
  WAYPOINT = 'WAYPOINT',
  BED = 'BED',
  ELEVATOR = 'ELEVATOR',
  ARMCHAIRS = 'ARMCHAIRS',
  VIP_ZONE = 'VIP_ZONE',
  SECURITY_POST = 'SECURITY_POST',
  CONFERENCE_HALL = 'CONFERENCE_HALL',
  SOCIAL_ROOM = 'SOCIAL_ROOM',
  WC = 'WC',
  CALL_CENTER = 'CALL_CENTER',
  STATISTICS = 'STATISTICS',
  TELEMEDICINE = 'TELEMEDICINE',
  ADMIN = 'ADMIN',
  CUSTOM = 'CUSTOM',
  CLOAKROOM = 'CLOAKROOM',
  WASHING = 'WASHING',
  DOOR = 'DOOR'
}

export enum IconType {
  DOCTOR = 'DOCTOR',
  NURSE = 'NURSE',
  ASSISTANT = 'ASSISTANT',
  PARAMEDIC = 'PARAMEDIC',
  RECEPTIONIST = 'RECEPTIONIST',
  PROTECTION = 'PROTECTION',
  BLOCK = 'BLOCK',
  WARNING = 'WARNING',
  EQUIPMENT = 'EQUIPMENT',
  BIOHAZARD = 'BIOHAZARD',
  INFO = 'INFO',
  BED = 'BED',
  CHAIR = 'CHAIR',
  WHEELCHAIR = 'WHEELCHAIR'
}

export interface MapIcon {
  id: string;
  x: number;
  y: number;
  type: IconType;
  label?: string;
  color?: string;
}

export interface Node {
  id: string;
  x: number;
  y: number;
  rotation?: number; 
  type: NodeType;
  label?: string; 
  connections: string[]; 
  capacity: number;
  occupants: string[]; 
  contamination: number; 
  processingTime: number; 
  speedModifier: number; 
}

export interface Wall {
  id: string;
  x1: number;
  y1: number;
  x2: number;
  y2: number;
}

export interface ZoneRect {
  x: number;
  y: number;
  w: number;
  h: number;
}

export interface Zone {
  id: string;
  type: NodeType;
  rects: ZoneRect[];
  label?: string;
  entryPointIds?: string[]; // Mazgų ID, kurie veikia kaip įėjimai/išėjimai šiai zonai
}

export interface PathPoint {
  x: number;
  y: number;
}

export type PathKind = 'SIMULATION' | 'ARCHITECTURAL';

export interface Path {
  id: string;
  name: string;
  points: PathPoint[];
  color: string;
  visible: boolean;
  /** Explicit kind replaces fragile name-based path classification. */
  kind?: PathKind;
  /** Node corresponding to each simulation path point, or null for a free point. */
  nodeIds?: Array<string | null>;
  /** Nodes created by this path and safe to remove with it when not shared. */
  generatedNodeIds?: string[];
  /** Graph edges introduced while drawing this simulation path. */
  connections?: Array<{ fromId: string; toId: string }>;
}
